<template>
  <section class="hero-slider">
    <transition-group name="hero-fade" tag="div" class="hero-slider__stage">
      <article v-for="slide in [slides[currentIndex]]" :key="slide.title" class="hero-slider__slide">
        <div class="hero-slider__media" :style="{ backgroundImage: 'linear-gradient(rgba(46,38,31,0.28), rgba(46,38,31,0.18)), url(' + slide.image + ')' }"></div>
        <div class="container hero-slider__content">
          <span class="eyebrow">{{ slide.eyebrow }}</span>
          <h1 class="hero-title">{{ slide.title }}</h1>
          <p class="hero-slider__copy">{{ slide.copy }}</p>
          <div class="hero-slider__actions">
            <router-link class="btn" :to="slide.primaryTo">{{ slide.primaryLabel }}</router-link>
            <router-link class="btn-outline" :to="slide.secondaryTo">{{ slide.secondaryLabel }}</router-link>
          </div>
        </div>
      </article>
    </transition-group>
    <div class="hero-slider__controls container">
      <button v-for="(slide, index) in slides" :key="slide.title" type="button" :class="['hero-slider__dot', { 'is-active': index === currentIndex }]" @click="goTo(index)"></button>
    </div>
  </section>
</template>

<script>
var slideContent = {
  en: [
    {
      eyebrow: 'Authentic Japan',
      title: 'Experience authentic Japan with your local experts',
      copy: 'Explore mysterious beauty of Japan through different seasons, cultures and local cuisine.',
      primaryLabel: 'Contact us with your request',
      primaryTo: '/contact',
      secondaryLabel: 'Explore Services',
      secondaryTo: '/services',
      image: '/images/banner1.png'
    },
    {
      eyebrow: 'Recommended Plans',
      title: 'Classic Tours & Recommended Itinerary',
      copy: '',
      primaryLabel: 'View Portfolio',
      primaryTo: '/portfolio',
      secondaryLabel: 'Contact Us',
      secondaryTo: '/contact',
      image: '/images/banner2.png'
    },
    {
      eyebrow: 'Why JBC Tours?',
      title: 'We design your tour with flexibility and creativity',
      copy: 'Speedy and detail-orientated communication. We create the quotation and respond to you within 1-3 working days. We can design your plan by various kinds of requests with our strong operation. We listen to your heart and build the trip with your true desire. Our team of diversity could answer you with multiple languages. We also have good connections with our partner company, including bus company, hotels, tour guides all over Japan. Any corner of Japan is covered by our services.',
      primaryLabel: 'Why Us',
      primaryTo: '/why-us',
      secondaryLabel: 'Contact Us',
      secondaryTo: '/contact',
      image: '/images/banner3.png'
    },
    {
      eyebrow: 'Testimonials',
      title: 'Testimonials & Reviews',
      copy: '',
      primaryLabel: 'Contact Us',
      primaryTo: '/contact',
      secondaryLabel: 'View Company',
      secondaryTo: '/company',
      image: '/images/banner4.png'
    }
  ],
  ja: [
    {
      eyebrow: '本物の日本',
      title: '日本の旅を、共にデザインする',
      copy: '日本の魅力的なビジュアル（四季・文化・食）',
      primaryLabel: '無料相談',
      primaryTo: '/contact',
      secondaryLabel: '事業内容を見る',
      secondaryTo: '/services',
      image: '/images/banner1.png'
    },
    {
      eyebrow: 'おすすめプラン',
      title: '人気ツアー・おすすめプラン',
      copy: '',
      primaryLabel: '実績案件を見る',
      primaryTo: '/portfolio',
      secondaryLabel: 'お問い合わせ',
      secondaryTo: '/contact',
      image: '/images/banner2.png'
    },
    {
      eyebrow: '選ばれる理由',
      title: '柔軟性と発想力を兼ね備えたチーム',
      copy: 'スピード感と対応力。お見積もりのリクエストには最短即日対応可、平均で1〜3営業日以内にご回答いたします。多様なニーズに応える企画・運営力。納得いただくまで寄り添う顧客対応力。多言語対応スタッフによる円滑なコミュニケーションに加え、日本全国に広がるバス会社・ホテル・通訳ガイドとのネットワークを活かし、都市部に限らない幅広い手配が可能です。',
      primaryLabel: '当社の強み',
      primaryTo: '/why-us',
      secondaryLabel: 'お問い合わせ',
      secondaryTo: '/contact',
      image: '/images/banner3.png'
    },
    {
      eyebrow: 'お客様の声',
      title: 'お客様の声・レビュー',
      copy: '',
      primaryLabel: 'お問い合わせ',
      primaryTo: '/contact',
      secondaryLabel: '会社概要を見る',
      secondaryTo: '/company',
      image: '/images/banner4.png'
    }
  ]
};

export default {
  name: 'HeroSlider',
  props: {
    language: {
      type: String,
      default: 'en'
    }
  },
  data: function () {
    return {
      currentIndex: 0,
      timer: null
    };
  },
  computed: {
    slides: function () {
      return slideContent[this.language] || slideContent.en;
    }
  },
  mounted: function () {
    this.startTimer();
  },
  beforeDestroy: function () {
    this.stopTimer();
  },
  methods: {
    startTimer: function () {
      this.stopTimer();
      this.timer = setInterval(this.nextSlide, 7000);
    },
    stopTimer: function () {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    nextSlide: function () {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    goTo: function (index) {
      this.currentIndex = index;
      this.startTimer();
    }
  }
};
</script>

<style scoped>
.hero-slider {
  position: relative;
  min-height: 100vh;
}

.hero-slider__stage,
.hero-slider__slide {
  min-height: 100vh;
}

.hero-slider__slide {
  position: relative;
  display: flex;
  align-items: center;
}

.hero-slider__media {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
}

.hero-slider__content {
  position: relative;
  z-index: 1;
  color: #fff;
  max-width: 780px;
  padding-top: 110px;
}

.hero-title {
  font-size: clamp(48px, 7vw, 88px);
  margin: 0;
  max-width: 780px;
}

.hero-slider__copy {
  max-width: 580px;
  font-size: 18px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.82);
  margin: 24px 0 0;
}

.hero-slider__actions {
  display: flex;
  gap: 16px;
  margin-top: 34px;
}

.hero-slider__controls {
  position: absolute;
  left: calc(50% - 48px);
  bottom: 42px;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 1;
}

.hero-slider__dot {
  width: 42px;
  height: 4px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.32);
}

.hero-slider__dot.is-active {
  background: #fff;
}

.hero-fade-enter-active,
.hero-fade-leave-active {
  transition: opacity 0.8s ease;
}

.hero-fade-enter,
.hero-fade-leave-to {
  opacity: 0;
}

@media (max-width: 767px) {
  .hero-slider__content {
    padding-top: 90px;
  }

  .hero-slider__actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-slider__copy {
    font-size: 16px;
  }
}
</style>
